import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class TerminalService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	//Create new terminal session
	createTerminalSession(userId, ipAddr, cols, rows, callback) {
		const url = "/terminal-app/api/terminals";
		const dataToPost = {
			userId: userId,
			ipAddr: ipAddr,
			cols: cols,
			rows: rows
		};

		const body = JSON.stringify(dataToPost);
		this._restClient.exec_post(url, body, callback);
	}

	//Resize current Terminal
	resizeTerminal(processId, cols, rows, callback) {
		const url = `/terminal-app/api/terminals/${processId}/resize`;
		const dataToPost = {
			cols: cols,
			rows: rows
		};

		const body = JSON.stringify(dataToPost);
		this._restClient.exec_post(url, body, callback);
	}

	//Execute command on current Terminal instance
	sendCommand(processId, command, callback) {
		const url = `/terminal-app/api/terminals/${processId}/command`;
		const body = JSON.stringify({ command });
		this._restClient.exec_post(url, body, callback);
	}

	//Close current Terminal instance
	closeTerminal(processId, callback) {
		const url = `/terminal-app/api/terminals/${processId}/close`;
		this._restClient.exec_post(url, null, callback);
	}

	//Subscribe to output received from Terminal
	subscribeTerminalIncomingData(processId, callback) {
		const args = {
			processId: processId
		};
		return this._rc.subscribe("terminal-app", "/terminals", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
}
